import api from '../api'
import { apiV2 } from '../api-new'
import { httpRequest } from '../http-request'
import { ProductResponse, TechnicalSheetResponse } from './dtos'

export const getProductContent = async (
  productId: number,
  accessToken: string
) => {
  apiV2.defaults.headers.authorization = `Bearer ${accessToken}`

  const response = await httpRequest<ProductResponse>({
    instance: apiV2,
    endpoint: `/canais/produtos/${productId}`,
  })

  return response
}

export const getProductTechnicalSheet = async (productId: number) => {
  const response = await httpRequest<TechnicalSheetResponse>({
    instance: api,
    endpoint: `/canais/produtos/${productId}/informacoes`,
  })
  return response
}
